export class TwilioUser {
  usid:             string;
  sid:              string;
  serviceName:      string;
  employeeId:       string;
}
